import { postAPI, uploadApi } from "../api";

export const makeSideBarActive = (menu: { icon: string, title: string, url: string, active: boolean }[], index: number) => {
    menu.map((item) => item.active = false);
    menu[index].active = true;
    return menu
}


export const timeSince = (date: any) => {
    let d: any = new Date(+date);
    let val: any = new Date()
    let seconds = Math.floor((val - d) / 1000);
  
    let interval = seconds / 31536000;
  
    if (interval > 1) {
        return Math.floor(interval) === 1 ? Math.floor(interval) + ' year ago' : Math.floor(interval) + " Years ago";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) === 1 ? Math.floor(interval) + ' month ago' : Math.floor(interval) + " months ago";
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) === 1 ? Math.floor(interval) + ' day ago' : Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) === 1 ? Math.floor(interval) + ' hour ago' : Math.floor(interval) + " hours ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) === 1 ? Math.floor(interval) + ' minute ago' : Math.floor(interval) + " minutes ago";
    }
    return Math.floor(interval) === 1 ? Math.floor(seconds) + ' second ago' : Math.floor(seconds) + " seconds ago";
  }

  export const priorityClass = (data: number | string) => {
  
    switch (data) {
      
      case 1:
        return 'priorityLow'
      
      case 2:
        return 'priorityMedium'
      
      case 3:
        return 'priorityHigh'
      case '1':
        return 'priorityLow'
      
      case '2':
        return 'priorityMedium'
      
      case '3':
        return 'priorityHigh'
  
    }
  }


  export const availablityInFilter = (data: any) => {
      
    switch (data) {
      case 1: 
       return 'Immediately'
      case 2:    
        return 'Coming date'
      case 3:
        return 'Coming weeks'
      case 4:
        return 'Unavailable for jobs'
      case 5:
        return 'In Contract'
      default:
        return 'Not Mentioned'
    }
  }




  export const checkPriority = (data: any) => {
  
  
    switch (data) {
      
      case '3':
        return 'Hot'
      
      case '2':
        return 'Warm'
      
      case '1':
        return 'Cold'
      
      case 1:
        return 'Cold'
      
      case 2:
        return 'Warm'
      
      case 3:
        return 'Hot'
      
     
    }
  }

  export const getMilliSec = (date: any) => {
    return new Date(date).getTime()
}
  
export const getMilliSecUTC = (date: any) => {
  let Adate = new Date(date)
  return  Date.UTC(Adate.getFullYear(),Adate.getMonth(),Adate.getDate())
 }

  export const convertMilliSecToDateNew = (date: any) => {
    if (date) {
        try 
        { return new Date(date).toDateString() }
        catch {
            return ''
        }
    } else {
        return ''
    }
  }

  export const checkAvailability = (data: any, date?: number | Date | undefined) => {
      

    switch (data && data.availability && data.availability) {
      case 1: 
       return 'Immediately'
      case 2:    
        let newDate :any = data.availability_date ? new Date(data.availability_date).toDateString().slice(3) : 'coming date'    
        return `I’m getting relieved from my current job by ${newDate}`
      case 3:
        let weeks: any = data.availability_week ? data.availability_week : 'coming'
        return `In ${weeks} weeks after I get the offer`
      case 4:
        return 'Unavailable for jobs'
      case 5:
        return 'In Contract'
      default:
        return 'Not Mentioned'
    }
  }

  export const checkFunctionality = (field:string,data: any) => {
  
  
    if (field === 'availabilityValue') {
     return checkAvailability(data,0)
    }
  
    if (field === 'priority'){
      return  checkPriority(data)
    }
    if(field === 'allocated_to'){
     return data
    }
    if(field === 'allocatedTo'){
        return data
    } 
}
  
export const checkSize = (size: number) => {
  switch (size) {
    case 0:
      return { id: 0, name: '0-10' }
    case 1:
      return { id: 1, name: '10-50' }
    case 2:
      return { id: 2, name: '50-100' }
}
}

export const checkActive = (status: number) => {
  switch (status) {
    case 2:
      return 'danger'
    case 4:
      return 'active'
    default:
      return 'danger'
  }
}

export const checkStatus = (status: number) => {
  switch (status) {
    case 2:
      return 'Enable'
    case 4:
      return 'Disable'
    default:
      return 'Enable'
  }
}



export const findFilterDate = (value: number) => {
  const today = new Date()

  switch (value) {
    case 1:
      return { from: new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000), to: today }
    case 2:
      return { from: new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000), to: today }
    case 3:
      return { from: new Date(today.getTime() - 90 * 24 * 60 * 60 * 1000), to: today }
    case 4:
      return { from: new Date(today.getTime() - 180 * 24 * 60 * 60 * 1000), to: today }
    case 5:
      return { from: new Date(today.getTime() - 365 * 24 * 60 * 60 * 1000), to: today }
  }
}

export const checkUserActiveStatus = (status: number) => {
  switch (status) {
    case 1:
      return 'Basic Registration'
    case 2:
      return 'Full Registration'
    case 3:
      return 'Call scheduled'
    case 4:
      return 'Approved'
    case 5:
      return 'Rejected'
    case 6:
      return 'Disabled as company is rejected'
    case 7:
      return 'Disabled'
    case 8:
      return 'Deleted'
  }
}

export const checkLevel = (level: number) => {
  switch (level) {
    case 1:
      return {
        title: 'Level 1 Developer',
        summary: 'A person with coding and unit testing experience'
      }
    case 2:
      return {
        title: 'Level 2 Developer',
        summary: 'A person with experience in designing along with coding and testing and can perform code reviews with ease.'
      }
      case 3:
        return {
          title: 'Level 3 Developer',
          summary: 'A person experienced in Designing, code reviewing, and mentoring junior developers'
      }
      case 4:
        return {
          title: 'Level 4 Developer',
          summary: 'A person experienced in Managing the team and assigning tasks along with excellent designing and coding skills.'
        }
  }
}

export const checkTimesheetStatus = (status: string) => {
  switch (status) {
    case '1':
      return {
        value: 'Draft',
        class: 'statusMessage Yellow'
      }
    case '2':
      return {
        value: 'Submitted',
        class: 'statusMessage Yellow'
      }
    case '3':
      return {
        value: 'Approved',
        class: 'statusMessage Green'
      }
    case '4':
      return {
        value: 'Rejected',
        class: 'statusMessage Red'
    }
    default:
      return {
        value: '',
        class: ''
    }
  }
}




